
/**MailingMethod
 * Omnicomposer =0,
 * HtmlUrl =1
 * HtmlFile=2,
 * zip = 3,
 * PicturelUrl= 4
 */
export const MAILING_METHOD = {
    Omnicomposer: 0,
    HtmlUrl: 1,
    HtmlFile: 2,
    Zip: 3,
    Picture: 4
};

export const VALID_TYPE = {
    Valid: 1,
    NotValidEmail: 2,
    NoEmail: 3,
    NeverSendMails: 4,
    NoMailings: 5,
};
